import { Grid } from 'ui';
import { container, dividers } from './receiptCssDefs';
import { useIsSmallScreen } from 'hooks/search/useIsBreakpointScreen';
import React from 'react';

interface ReceiptProps {
  activateAccount?: React.ReactNode | null;
  reservationSummary?: React.ReactNode | null;
  sectionHeader?: React.ReactNode;
  reservationDetails?: React.ReactNode | null;
  previsitQuestions: React.ReactNode;
  callout: React.ReactNode;
  mobileTicket: React.ReactNode;
  rightColumn?: React.ReactNode | null;
  messageFromBusiness?: React.ReactNode | null;
  resyCreditBanner?: React.ReactNode | null;
  continueMultiCheckout?: React.ReactNode | null;
}

/**
 * <Receipt/> component is simple presentational skeleton with assigned slots.
 * It only accepts React element and place them on the grid.
 * It is meant to remove unecessary levels of component nesting and avoid props drilling.
 */

export const Receipt: React.FC<ReceiptProps> = ({
  sectionHeader,
  activateAccount,
  reservationDetails,
  reservationSummary,
  previsitQuestions,
  callout,
  mobileTicket,
  rightColumn,
  messageFromBusiness,
  resyCreditBanner,
  continueMultiCheckout,
}) => {
  const isScreenSmall = useIsSmallScreen();

  return (
    <div css={container}>
      <Grid container spacing={isScreenSmall ? 4 : 2}>
        {(sectionHeader || callout) && (
          <Grid item xs={12}>
            {sectionHeader}
          </Grid>
        )}
        <Grid item md={7} xs={12} css={dividers}>
          {continueMultiCheckout}
          {callout}
          {reservationSummary}
          {mobileTicket}
          {previsitQuestions}
          {messageFromBusiness}
          {resyCreditBanner}
          {activateAccount}
          {reservationDetails}
        </Grid>
        <Grid item md={5} xs={12}>
          {rightColumn}
        </Grid>
      </Grid>
    </div>
  );
};
